export const labelids = {
  labelid: {
    LBLC010001_01:
      "　IDとパスワードを入力し、「ログイン」ボタンを押してください。",
    LBLC010002_01:
      "　パスワード再発行用のリンクをお送りするため「ログインID」または、「共済契約者番号」を入力してください。\\n　「パスワード発行リンク送信」ボタンを押して頂くと、登録したメールアドレスにリンクが届きます。",
    LBLC010003_01:
      "　新しく設定するパスワードを入力し、「登録」ボタンを押してください。\\n　パスワードには、英大文字、英小文字、数字、記号（!\"#$%&'()*+,-./:;<=>?@[]^_`{|}~）をそれぞれ最低１つずついれてください。\\n　（１０～２４文字以内）",
    LBLC010004_01:
      "　登録メールアドレスの変更にあたって次の項目の情報を入力してください。\\n　入力内容に誤りがないことを確認後、「機構へ提出する」ボタンを押してください。",
    LBLC030001_01:
      "　契約のお申込みにあたって次の項目の情報を入力してください。\\n　登録内容に誤りがないことを確認後、「機構へ提出する」ボタンを押してください。\\n　機構側で登録内容を確認後、ご登録いただいたメールアドレス宛にログイン用URLを送付します。\\n　なお、契約申込み時には法人の履歴事項全部証明書（提出日の前3か月以内に作成されたもの）、就業規則、給与規程が必要となりますので、予めご用意ください。\\n　※登録内容について、お電話にてご照会をさせていただくことがあります。",
    LBLC030102_01: "　法人情報を確認してください",
    LBLC030102_02: "　本共済契約の申込み担当者の情報を確認してください",
    LBLC040004_01:
      "　入力した内容を確認後、「機構へ提出する」ボタンを押してください。",
    LBLC040004_02: "　法人として認められている手当の一覧です。",
    LBLC040004_03:
      "　申請をする手当の名称と給与規程の対応規程を入力してください。",
    LBLC040004_04: "　施設を選択してください。",
    LBLC040004_05:
      "　申請する規程に該当する条文の該当部分をそのまま記載し、基本事項を満たしているか確認してください。\\n　※「処遇改善加算」等（介護職員処遇改善支援補助金を含む）が支給財源であることの表記がある場合は、基本事項①～③のすべてにチェックをつけて提出してください。",
    LBLC040004_06: "　給与規程をアップロードしてください。",
    LBLC040103_01:
      "　すでに申請されている「俸給の調整額」対象手当が一覧に表示されています。\\n　「俸給の調整額」対象手当を新規に申請する場合には「追加登録の申請画面へ」ボタンをクリックしてください。",
    LBLC040106_01:
      "　契約者名または、担当者情報を入力してください。\\n　内容に誤りが無いことを確認後、「更新」ボタンを押してください。",
    LBLC050009_01:
      "　以下の内容で機構へ提出します。\\n　内容に間違いが無いことを確認後、「機構へ提出する」ボタンを押してください。",
    LBLC050012_01:
      "　以下の内容で機構へ提出します。\\n　内容に間違いが無いことを確認後、「機構へ提出する」ボタンを押してください。",
    LBLC050016_01:
      "　以下の内容で機構へ提出します。\\n　内容に間違いが無いことを確認後、「機構へ提出する」ボタンを押してください。",
    LBLC050017_01:
      "　施設情報の変更する内容（「施設の名称」「施設の所在地」「施設種類」）を選択し、必要項目を入力してください。\\n　内容に誤りがないことを確認し、「機構へ提出する」ボタンをクリックしてください。",
    LBLC050018_01:
      "　施設種類の変更手続きが取られたことにより、施設区分が「社会福祉施設等」から「特定介護保険施設等」に変更となります。\\n　それに伴い、施設種類が変更された日以後に採用された職員については、掛金の公費負担がなくなり、掛金負担が３倍となります。\\n　今後、施設種類の変更（転換）された日以後に採用された職員について加入させない場合は、画面下部にある「機構へ提出する」ボタンを押してください。",
    LBLC050019_01:
      "　制度改正後の職員を加入させない手続き、部分解除手続き等を届け出ている施設等において、当該届出を取下げ、新規で採用した職員も加入させる場合は、「届出中の施設」から施設を選択し、表示内容を確認後、取り下げボタンを押してください。",
    LBLC050019_02:
      "　なお、取下げる際は恐れ入りますが1施設ごとに行っていただきますようお願いいたします。",
    LBLC050024_01:
      "　以下の内容で機構へ提出します。\\n　内容に間違いが無いことを確認後、「機構へ提出する」ボタンを押してください。",
    LBLC050028_01:
      "　以下の内容で機構へ提出します。\\n　内容に間違いが無いことを確認後、「機構へ提出する」ボタンを押してください。",
    LBLC050029_01:
      "　措置入所障害児関係業務従事職員数または特定職員数が異なる場合訂正してください。\\n　入力内容を確認後、「登録」ボタンを押してください。",
    LBLC050101_01:
      "　新規で登録する施設の情報を入力してください。\\n　なお、施設の経営移管等により引継ぎコードがある場合は、引継ぎコードを入力し、「読み込み」ボタンを押して登録をしてください。\\n　※一つの施設内で複数の事業を行っている場合は、まとめて１施設で登録するのではなく、事業ごとに登録してください。",
    LBLC050102_01:
      "　「社会福祉施設等」については、経営する施設・事業を全て登録してください。\\n　「特定介護保険施設等」「申出施設等」については、契約対象として申出する施設・事業のみ登録してください。\\n　なお、施設の経営移管等により引継ぎコードがある場合は、引継ぎコードを入力し、読み込みボタンを押して登録をしてください。\\n　※一つの施設内で複数の事業を行っている場合は、まとめて１施設で登録するのではなく、事業ごとに登録してください。\\n　（例示：障害者支援施設ＷＡＭさくら園（生活介護）、障害者支援施設ＷＡＭさくら園（自立訓練）等）",
    LBLC050103_01:
      "　「社会福祉施設等」については、経営する施設・事業を全て登録してください。\\n　「特定介護保険施設等」「申出施設等」については、契約対象として申出する施設・事業のみ登録してください。\\n　なお、施設の経営移管等により引継ぎコードがある場合は、引継ぎコードを入力し、読み込みボタンを押して登録をしてください。\\n　※一つの施設内で複数の事業を行っている場合は、まとめて１施設で登録するのではなく、事業ごとに登録してください。\\n　（例示：障害者支援施設ＷＡＭさくら園（生活介護）、障害者支援施設ＷＡＭさくら園（自立訓練）等）",
    LBLC050103_02:
      "　すべての施設の職員登録が完了したら、「登録完了」ボタンを押下してください。",
    LBLC050104_02:
      "　ア　雇用期間に定めのない職員（いわゆる正規職員）\\n　イ　一年以上の雇用期間を定めて使用される職員で、労働時間が就業規則で定める正規職員の所定労働時間の３分の２以上のもの\\n　ウ　一年未満の雇用期間を定めて使用され、期間の更新により引き続き１年を経過した職員で、労働時間が就業規則で定める正規職員の所定労働時間の３分の２以上のもの",
    LBLC050105_01: "　施設情報を確認してください",
    LBLC050106_01:
      "　経営者でなくなった理由を選択し、廃止・休止・経営移管したことを証明したことを証明する書類を添付してください。\\n　経営移管した場合には、共済契約者番号、共済契約者名を入力してください。\\n　なお、新規契約法人の場合は、共済契約者番号は入力不要です。",
    LBLC050107_01:
      "　施設の処理状況欄に「未登録」「登録中」が存在する場合は、「登録」ボタンを押して、職員の異動状況を登録してください。\\n　すべての施設の処理状況欄が「登録済み」になっていることを確認し、画面下部にある「次へ」ボタンを押してください。",
    LBLC050107_02:
      "　すべての施設の処理状況列が「登録済み」になっていることを確認後、「次へ」ボタンを押してください。",
    LBLC050108_01:
      "　経営者でなくなった日をもって、在籍している職員の異動状況を選択し、「登録」ボタンを押してください。",
    LBLC050110_01:
      "　中小企業退職金共済制度との共済契約締結日、同共済契約者番号、締結の理由について入力し、画面下部にある「次へ」ボタンを押してください。",
    LBLC050110_02:
      "　各施設の職員の状況は「表示」ボタンを押すことで確認ができます。",
    LBLC050110_03:
      "　入力した内容、各施設の職員従業状況が最新になっていることを確認後、「次へ」ボタンを押してください。",
    LBLC050113_01:
      "　各施設の職員の従業状況は、従業状況確認欄の「表示」ボタンを押すことで確認できます。\\n　解除にあたって、解除同意書をダウンロードして、各職員の同意（署名、押印）を得たのち、当該同意書をアップロードしてください。",
    LBLC050113_02:
      "　解除年月日、解除理由を入力してください。\\n　解除理由は具体的に記入してください。",
    LBLC050113_03: "　内容を確認後、「次へ」ボタンを押してください。",
    LBLC050114_01:
      "　各施設の従業状況欄にある「更新」ボタンを押して、従業状況を最新の状況に更新してください。",
    LBLC050114_02: "　従業状況を更新後、「次へ」ボタンを押してください。",
    LBLC050115_01:
      "　直近3ヶ月の退職者に対して、雇用保険資格喪失証明書等の登録をしてください。",
    LBLC050120_01:
      "　廃止、休止又は経営移管する施設を選択し、「次へ」ボタンを押してください。",
    LBLC050121_01:
      "　廃止、休止又は経営移管する施設を確認し、「施設情報」欄、「職員の異動状況」欄の「登録」ボタンを押して、届出内容を入力してください。\\n　すべての施設の処理状況欄が登録完了となっていることを確認し、「次へ」ボタンを押してください。",
    LBLC050122_01:
      "　理由を選択し、廃止・休止又は経営移管が確認できる書類の添付、及び廃止・休止または経営移管年月日を入力してください。\\n　なお、経営移管を選択した場合は、経営移管後の共済契約者番号（新規契約の場合は不要）、共済契約者名を入力してください。",
    LBLC050125_01:
      "　特定介護保険施設等又は申出施設等のうち、以下の部分については対象職員の同意を得ることで、共済契約を解除することが可能です。\\n　　・対象施設の被共済職員\\n　　・平成18年以降に加入した被共済職員\\n　　・平成28年以降に加入した被共済職員\\n　　・施設転換後の被共済職員\\n　解除する場合は、対象となる施設を選択し、「次へ」ボタンを押してください。",
    LBLC050126_01:
      "　対象施設の解除情報欄にある「登録」ボタンを押して、内容を入力してください。\\n　処理状況がすべて登録済みになっていることを確認し、「次へ」ボタンを押してください。",
    LBLC050127_01:
      "　以下の必要事項を入力し、内容に誤りがないことを確認し、画面下部にある「登録」ボタンを押してください。\\n　解除対象となる職員の範囲を選択してください。",
    LBLC050127_02:
      "　解除対象となる職員の従業状況が最新の状況となっているか「表示」ボタンを押すことで確認ができます。\\n　また、解除日から直近３カ月以内に退職者がいる場合は、「直近3カ月の退職者の証明書」欄の「登録」ボタンを押し、「雇用保険資格喪失証明書」等をアップロードしてください。",
    LBLC050127_03:
      "　「職員名簿をダウンロード」ボタンを押して職員名簿のダウンロードを行ない、解除対象の被共済職員全員の同意をえてください。",
    LBLC050127_04:
      "　解除年月日、部分解除の人数を確認し、対象となる全員の同意書をアップロードしてください。\\n　また、解除理由を具体的に記入してください。",
    LBLC050127_05:
      "　入力した内容、解除対象となる職員従業状況が最新になっていることを確認し、「登録」ボタンを押してください。",
    LBLC060009_01:
      "　入力内容を確認してください。\\n　この内容で、よろしければ「入力完了」ボタンを押してください。\\n　他にも加入登録する職員がいる場合は「同じ施設で続けて入力」ボタンか「違う施設で続けて入力」ボタンを押してください。",
    LBLC060013_01:
      "　以下の被共済職員については、次のいずれかに該当する職員です。\\n　　・共済契約対象外施設に異動した職員\\n　　・共済契約対象外施設から共済契約対象施設に復帰した職員\\n\\n　異動・復帰登録欄の登録ボタンを押して、必要事項を入力してください。\\n　処理状況欄がすべて「登録済み」になったことを確認し、「機構へ提出する」ボタンを押してください。",
    LBLC060028_01:
      "　登録内容を確認し、誤りがなければ、「機構へ提出」ボタンを押してください。",
    LBLC060031_01:
      "　退職情報の登録状況を表示しています。\\n　「書類の添付」又は「源泉徴収票」の登録が必要な方については、「登録」ボタンを押して、情報を登録してください。\\n　必要な書類の登録後、退職手当金の支給手続きを行います。\\n　※「登録」ボタンが表示されている場合は、当該退職者の退職金は支給されません。",
    LBLC060101_01:
      "　育児休業の取得状況を入力してください。\\n　入力した内容を確認後、間違いがなければ、「確認」ボタンを押してください。\\n　なお、出生日を入力すると「育児休業開始日」と「育児休業終了（予定）日」は自動的に初期表示されますが、必要な場合は修正入力が可能です。",
    LBLC060102_01: "　育児休業を次のとおり登録します。",
    LBLC060102_02:
      "　次の月について、出勤日数を入力してください。\\n　有給休暇については、１年につき２０日を限度として出勤日扱いとできます。\\n　なお、１日に満たない日は切り上げて入力してください（例示：１０日と半日勤務は「１１」日と入力）。",
    LBLC060103_01:
      "　配置換えをする職員がいる場合には、対象の職員の選択欄にチェックを入れて「配置換え入力」ボタンをクリックしてください。\\n　異動先の施設、異動日が同じ職員が複数いる場合には、複数の職員にチェックを入れていただくことで、一括で登録することができます。\\n　施設を選択すると職員の登録内容が表示されます。",
    LBLC060104_01:
      "　配置換えをする施設を選択し、配置換え先施設の配属日を入力してください。\\n　入力した内容を確認後、間違いが無ければ「登録」ボタンを押してください。",
    LBLC060104_02: "配置換えの対象となる職員氏名です。",
    LBLC060104_03: "配置換えの元施設（異動前の施設）の名称です。",
    LBLC060104_04: "配置換え先の施設名を選択してください。",
    LBLC060104_05:
      "配置換え先の施設に配属された日を登録してください。\\n直接入力していただくか、「カレンダーボタン」にて日付を選択してください。",
    LBLC060106_02:
      "　ア　雇用期間に定めのない職員（いわゆる正規職員）\\n　イ　一年以上の雇用期間を定めて使用される職員で、労働時間が就業規則で定める正規職員の所定労働時間の３分の２以上のもの\\n　ウ　一年未満の雇用期間を定めて使用され、期間の更新により引き続き１年を経過した職員で、労働時間が就業規則で定める正規職員の所定労働時間の３分の２以上のもの",
    LBLC060110_01:
      "　次の内容で、加入登録を行います。\\n　よろしければ、「機構へ提出」ボタンを押してください。",
    LBLC060111_01:
      "　配置換えをする職員がいる場合には、対象の職員の選択欄にチェックを入れて「登録」ボタンをクリックしてください。\\n　異動先の施設、異動日が同じ職員が複数いる場合には、複数の職員にチェックを入れていただくことで、一括で登録することができます。\\n　施設を選択すると職員の登録内容が表示されます。",
    LBLC060112_01: "　施設を選択すると職員の登録内容が表示されます。",
    LBLC060112_02:
      "　１）「ならない月」を登録してください。　\\n　２）育児休業をとった職員、育児休業の終了日を変更する職員がいる場合に、登録してください。　\\n　３）退職予定の職員がいる場合に退職予定日を登録してください。　",
    LBLC060114_01:
      "　復帰時の職種・本俸月額を入力して「登録」ボタンを押してください。",
    LBLC060115_01:
      "　異動後の施設情報、従業状況、異動した月以前の６か月の本俸月額を入力して「登録」ボタンを押してください。",
    LBLC060116_01: "　施設を選択すると職員の登録内容が表示されます。",
    LBLC060119_02:
      "　退職情報を登録します。\\n　登録前の事前確認として、次の各項目について選択し、「次へ」ボタンを押してください。",
    LBLC060120_01:
      "　対象者の基本情報を入力し、「次へ」ボタンを押してください。",
    LBLC060121_01:
      "　登録いただいた退職理由等から次の書類が必要となります。\\n　後で登録いただくことも可能です。\\n　内容を確認後、「次へ」ボタンを押してください。",
    LBLC060122_01:
      "　退職者の従業状況（退職月の直前の4月から退職月までの期間）が正しいことを確認し、「次へ」ボタンを押してください。",
    LBLC060123_01:
      "　退職者の「退職した月以前６か月」の本俸月額登録が正しいことを確認して「次へ」ボタンを押してください。",
    LBLC060124_01:
      "「退職所得の源泉徴収票」の入力・添付については、今後、「退職手当金請求」申請時に行う運用へ変更いたしました。\\n複数個所から退職手当金を受け取る場合は、福祉医療機構の退職手当金より前に受け取る退職手当金に係る「退職所得の源泉徴収票」の入力・添付を、「退職手当金請求」申請時に行っていただく必要があります。つきましては、その旨を退職者（請求者）の方へご案内ください。\\nまた、退職者へQRコードをお渡しする際は、都道府県社会福祉協議会等が発行した「退職所得の源泉徴収票」をお持ちの場合、その源泉徴収票もあわせてお渡しください。\\nなお、システムの完全切替は令和9年1月を予定しております。",
    LBLC060127_01:
      "　次のいずれの条件にも当てはまる場合、転職先の共済契約者の共済契約者番号、共済契約者名を入力し、次ヘボタンを押してください。",
    LBLC060129_01:
      "　退職手当金請求にはこの画面に表示されている退職者識別コードが必要となります。表示されている退職者識別コードを退職者に伝えてください。",
    LBLC060130_01:
      "　画面に表示されている引継ぎコードを転職先の共済契約者（次の勤務先）に必ず伝えてください。\\n　伝えられない場合は、今まで勤務していた期間（被共済職員期間）を次の勤務先での勤務期間（被共済職員期間）と通算することができなくなります。",
    LBLC060132_01: "　退職者情報を確認してください。",
    LBLC060134_01: "　請求者を選択すると登録内容が表示されます",
    LBLC070007_01: "　登録方法を選択して「次へ」ボタンを押してください。",
    LBLC070007_02:
      "　代行依頼をするためには、共済契約者ホーム画面の「対応が必要な手続き」欄に依頼したい手続きが表示されている必要があります。\\n　本部と施設担当者で同じ手続きをする場合、本部担当者が先に手続きをしてしまうと「対応が必要な手続き」欄から、その手続きが消えてしまいますので、（代行依頼で依頼した）施設担当者等が“先に”手続きをし、その後、本部担当者が手続きをしてください。\\n　なお、本部担当者が手続きをして「対応が必要手続き」から、代行依頼したい手続きが消えた場合には、１日待つことで、再び「対応が必要な手続き」に手続きが表示されますので、１日待って施設担当者等へ代行の依頼をしてください。\\n　なお、「代行依頼」ができるのは、次の５つの手続きです。被共済職員加入届の提出、従業状況の更新、配置換え登録、本俸月額の更新、被共済職員退職届の提出。退職手当金請求書の作成は施設担当者等の代行者が行うことはできません。",
    LBLC070008_02: "　「ホームへ戻る」ボタンを押してください。",
    LBLC070008_03: "　提出完了しました。このページを閉じてください。",
    LBLC070105_01:
      "　振込金返還請求書の内容にあたって次の項目の情報を入力してください。\\n　入力内容に誤りがないことを確認後、「機構へ提出する」ボタンを押してください。",
    LBLC080006_02: "　※５月３１日までに納付してください。",
    LBLC080007_02:
      "　掛金納付対象職員届の控えは「掛金納付対象職員届控えダウンロード」ボタンを押してダウンロードしてください。\\n\\n　※掛金納付対象職員届の作成にあたり、事前に各種諸届の手続きを実施いただいているため、「異動理由」、「異動日」については控えに表示しておりませんが、加入日等は職員照会画面から確認いただくことが可能です。",
    LBLC080009_01:
      "　掛金の納付期限延長にかかる次の事項を入力してください。\\n　入力内容を確認後、「機構へ提出する」ボタンを押してください。",
    LBLC080104_01:
      "　※職員番号★…平成１８年３月３１日までの加入者\\n　※職員番号◆…平成１８年４月１日から平成２８年３月３１日までの加入者\\n　※職員番号☆…施設転換前の加入者\\n　※加入資格ア、イ、ウの説明\\n　　ア…雇用期間に定めのない職員（いわゆる正規職員）\\n　　イ…一年以上の雇用期間を定めて使用される職員で、労働時間が就業規則で定める正規職員の所定労働時間の３分の２以上もの\\n　　ウ…一年未満の雇用期間を定めて使用され、期間の更新により引き続き１年を経過した職員で、労働時間が就業規則で定める正規職員の所定労働時間の３分の２以上もの",
    LBLC100001_01:
      "　手続きについて、各施設の担当者等に処理を代行してもらう場合は、最初に「代行者の一覧・新規登録」ボタンを押してください。\\n　代行者を登録後、処理を依頼する場合は、「新規依頼」ボタンを押して内容を入力してください。\\n　「再依頼」ボタンを押すことで再度担当者に処理をすることが可能です。また、「参照依頼」ボタンを押すことで、過去の依頼内容を参照し、新規の依頼が可能です。",
    LBLC100002_01: "　登録されている代行者の一覧",
    LBLC100003_01: "　代行者を登録してください。",
    LBLC100005_01: "　代行者を指定してください。",
    LBLC100006_01:
      "　表示されている内容を確認し、画面の下部にある「代行者に再依頼」ボタンを押してください。",
    LBLC100006_02:
      "　表示されている内容を確認し、画面の下部にある「代行者に依頼」ボタンを押してください。",
    LBLD310001_01:
      "　次の内容について代行依頼が届いていますので、処理を行ってください。",
    LBLD310002_01:
      "　依頼された作業を終えたら「完了報告ボタン」を押して依頼者に報告します。",
    LBLR010001_01:
      "　登録されているメールアドレスに送付された認証コードを入力してください。",
    LBLR410001_01:
      "　次の項目の内容を入力し、「登録」ボタンを押してください。\\n　「退職手当金請求書」のＵＲＬリンクを登録したメールアドレス宛に送信します。",
    LBLR410003_01:
      "　退職手当金の請求にあたって、次の書類を事前にご用意ください。\\n　なお、請求者様の状況によって他の書類も必要となる場合があります。",
    LBLR410003_02:
      "　１. 退職手当金振込先金融機関の通帳の「表紙」の写しと見開きページの写し",
    LBLR410003_03:
      "　２. 個人番号を確認する書類（写し）\\n　　次のいずれかが必要です\\n　　①個人番号カード（マイナンバーがある面）\\n　　②番号通知カード（表示されている氏名、住所に変更がない場合のみ有効です）\\n　　③個人番号が記載された住民票",
    LBLR410003_04:
      "　３. 本人であることを確認する書類\\n　　（１）顔写真のある公的な証明書は次のいずれか１種類を選んで提出してください。\\n　　　①個人番号カード（顔写真のある面）\\n　　　②運転免許証（表裏両面）\\n　　　③運転経歴証明書\\n　　　④旅券（パスポート）\\n　　　⑤身体障害者手帳\\n　　　⑥療育手帳\\n　　　⑦顔写真付きの国家資格免許証\\n　　（２）顔写真のないものは次の中から２種類を選んで提出してください。\\n　　　①健康保険証　　　②年金手帳\\n　　　③公共料金の領収書\\n　　　④住民票\\n　　　⑤雇用保険被保険者証\\n　　　⑥基礎年金番号通知書\\n　　　⑦給与所得の源泉徴収票\\n　　　⑧受理証明書（婚姻・離婚）\\n　　　⑨母子手帳（名前と生年月日があるページ）",
    LBLR410003_05:
      "　４. 氏名を変更している場合は、変更していることを確認する書類\\n　　①運転免許証（表裏）\\n　　②戸籍抄本\\n　　③旧姓と新姓が確認できる住民票\\n　　④個人番号カード（新旧姓の記載のあるもの）",
    LBLR410003_06:
      "　１. 退職手当金振込先金融機関の通帳のアップロードできるようファイル（画像等）で保存できていますか？",
    LBLR410003_07:
      "　２. 個人番号を確認する書類（写し）をアップロードできるようファイル（画像等）で保存できていますか？",
    LBLR410003_08:
      "　３. 本人であることを確認する書類をアップロードできるようファイル（画像等）で保存できていますか？",
    LBLR410003_09:
      "　４. 退職手当金請求処理の委任状をアップロードしてください。",
    LBLR410004_01:
      "　今回の手続きは次の方を対象としています。\\n　表示内容に誤りがないことを確認し、「次へ」ボタンを押してください。\\n　内容に誤りがある場合は、勤務先へ連絡してください。",
    LBLR410004_02:
      "　＜個人情報の取扱いについて＞\\n　請求者又は退職者に係る個人情報は、退職手当共済業務及び付帯する業務の範囲内で利用されます。",
    LBLR410004_03:
      "　＜留意事項について＞\\n　・退職手当金を請求いただいた場合であっても、審査により支給できない場合があります。\\n　・退職手当金の支給財源の都合により、支給時期が遅れることがあります。",
    LBLR410004_04: "合算制度利用申出の委任状をアップロードしてください。",
    LBLR410016_01:
      "　次の内容で退職手当金を請求します。\\n　登録内容を確認し、誤りがなければ、機構へ提出ボタンを押してください。",
    LBLR410016_02:
      "　【郵送先】〒105－8486\\n　　　　　　東京都港区虎ノ門４－３－１３　ヒューリック神谷町ビル９階\\n　　　　　　独立行政法人福祉医療機構　共済部退職給付課　宛",
    LBLR410017_01:
      "　次の内容で合算制度利用申出を行います。\\n　登録内容を確認し、誤りがなければ、機構へ提出ボタンを押してください。",
    LBLR410022_01:
      "　次の内容で退職手当金の受領者の変更を機構へ連絡します。\\n　登録内容を確認し、誤りがなければ、「機構へ提出する」ボタンを押してください。\\n　機構で内容を確認後、退職手当金の請求フォームへのURLをメールにてお送りします。",
    LBLR410022_02:
      "　必要書類に戸籍謄本が含まれる場合には、以下に郵送してください。",
    LBLR410022_03:
      "　【郵送先】〒105－8486\\n　　　　　　東京都港区虎ノ門４－３－１３　ヒューリック神谷町ビル９階\\n　　　　　　独立行政法人福祉医療機構　共済部退職給付課　宛",
    LBLR410027_01:
      "　次の内容で受領者を変更し、退職手当金を請求します。\\n　登録内容を確認し、誤りがなければ、「機構へ提出する」ボタンを押してください。",
    LBLR410027_02:
      "　次の内容で受領者を変更し、退職手当金を請求します。\\n　登録内容を確認し、誤りがなければ、「申請」ボタンを押してください。",
    LBLR410028_01:
      "　退職手当金の請求をいただきましたが、指定いただいた金融機関に退職手当金を振り込むことができませんでした。\\n　現在登録されている振込先金融機関の情報を確認いただき、正しい情報に変更後、再度機構に振込先金融機関の情報を提出してください。\\n　なお、請求者の死亡等により、振込先口座が凍結されている場合は、「受領者変更」ボタンから請求者の情報を入力してください。　",
    LBLR410028_02:
      "　上記現在登録されている内容を確認後、正しい情報を以下に入力して「機構へ提出する」ボタンを押してください。",
    LBLR410028_03:
      "　変更後の振込先口座が確認できる書類をアップロードしてください。\\n　また、氏名が変更されている場合は、変更されていることが確認できる書類（戸籍抄本/免許証（表裏）/旧姓と新姓が確認できる住民票）もアップロードしてください。",
    LBLR410030_01:
      "　退職手当金の請求、振込状況は次のとおりです。\\n　表示されている退職手当金の支給額、振込日は目安です。実際の金額、振込日とは異なることがあります。\\n　なお、今回の請求を取り下げる場合は、「退職金請求の取下げ」ボタンを押してください。",
    LBLR411105_01: "　該当する退職手当金の請求者区分を選択してください。",
    LBLR411105_02:
      "　（※1）請求者が戸籍上の配偶者又は内縁の夫・妻以外の場合は、勤務先法人から生活維持の有無を証明する書類（生計維持に関する調査書）の提出が別途必要となります。\\n　（※2）あなたと同順位の請求権保持者がいる場合、書類（委任状）の提出が別途必要となります。",
    LBLR411105_03:
      "　\\n　以下に、遺族請求時に必要な書類の一覧を記載します。\\n　退職手当金の請求に必要ですので、ご準備ください。\\n　",
    LBLR411105_04:
      "　\\n　以下に、相続人請求時に必要な書類の一覧を記載します。\\n　退職手当金の請求に必要ですので、ご準備ください。\\n　",
    LBLR411105_05: "　遺族請求時に必要な書類一覧",
    LBLR411105_06: "　相続人請求時に必要な書類一覧",
    LBLR411105_07:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 配偶者の「戸籍謄本」（但し、職員の死亡後に別戸籍となっている場合は、配偶者の「戸籍謄本」のほか職員の死亡を証する「戸籍謄本」又は「除籍謄本」）",
    LBLR411105_08:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡及び戸籍上の配偶者がいないことを証する「戸籍謄本」又は「除籍謄本」\\n　　3. 内縁の妻又は夫の「戸籍謄本」\\n　　4. 内縁関係についての「生計維持に関する調査書」（様式１１号）\\n　　5. 職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」\\n　　6. その他、事実上の配偶者であることを証明する書類",
    LBLR411105_09:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）\\n　　3. 職員の死亡を証する「戸籍謄本」又は「除籍謄本」\\n　　4. 職員と請求者（受給権者）の身分関係及び先順位の遺族がいないことを証する「戸籍謄本」(「除籍謄本」、「改製原戸籍謄本」を含む）\\n　　5. 請求者（受給権者）の現在の「戸籍抄本」又は「戸籍謄本」　　※上記３又は４の戸籍謄本より請求者（受給権者）が除籍されている場合\\n　　6. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411105_10:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）\\n　　3. 「認証文つき法定相続情報一覧図の写し」\\n　　4. 職員の死亡を証する「戸籍謄本」又は「除籍謄本」　　　　　　※上記3がない場合\\n　　5. 職員と請求者（受給権者）の身分関係及び先順位の遺族がいないことを証する「戸籍謄本」(「除籍謄本」、「改製原戸籍謄本」を含む）　　　　　　※上記3がない場合\\n　　6. 請求者（受給権者）の現在の「戸籍抄本」又は「戸籍謄本」　　※上記４又は５の戸籍謄本より請求者（受給権者）が除籍されている場合\\n　　7. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411105_11:
      "　　1. 「認証文つき法定相続情報一覧図の写し」\\n　　2. 職員の相続人（受給権者）を証する「戸籍謄本」　　　　　　※上記1がない場合\\n　　3. 相続人（受給権者）全員の現在の「戸籍抄本」又は「戸籍謄本」　　　　　　※上記1がない場合\\n　　4. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",

    LBLR411106_01:
      "　次の項目について、請求者の情報を入力してください。\\n　初期表示されている内容と事実が異なる場合は、内容修正してください。",
    LBLR411107_01:
      "　退職手当金の振込先金融機関を登録し、「次へ」ボタンを押してください。\\n　なお、請求者が退職者本人である場合は、退職手当金の振込先金融機関の口座は本人名義のみとなります。",
    LBLR411108_01:
      "　今回の退職手当金の請求にあたって、次の書類の添付が必要となります。\\n　それぞれ添付をアップロードし、次へボタンを押してください。",
    LBLR411108_02: "　遺族請求時に必要な書類一覧",
    LBLR411108_03: "　相続人請求時に必要な書類一覧",
    LBLR411108_04:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 配偶者の「戸籍謄本」（但し、職員の死亡後に別戸籍となっている場合は、配偶者の「戸籍謄本」のほか職員の死亡を証する「戸籍謄本」又は「除籍謄本」）",
    LBLR411108_05:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡及び戸籍上の配偶者がいないことを証する「戸籍謄本」又は「除籍謄本」\\n　　3. 内縁の妻又は夫の「戸籍謄本」\\n　　4. 内縁関係についての「生計維持に関する調査書」（様式１１号）\\n　　5. 職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」\\n　　6. その他、事実上の配偶者であることを証明する書類",
    LBLR411108_06:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）\\n　　3. 職員の死亡を証する「戸籍謄本」又は「除籍謄本」\\n　　4. 職員と請求者（受給権者）の身分関係及び先順位の遺族がいないことを証する「戸籍謄本」(「除籍謄本」、「改製原戸籍謄本」を含む）\\n　　5. 請求者（受給権者）の現在の「戸籍抄本」又は「戸籍謄本」　　※上記３又は４の戸籍謄本より請求者（受給権者）が除籍されている場合\\n　　6. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411108_07:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）\\n　　3. 「認証文つき法定相続情報一覧図の写し」\\n　　4. 職員の死亡を証する「戸籍謄本」又は「除籍謄本」　　　　　　※上記3がない場合\\n　　5. 職員と請求者（受給権者）の身分関係及び先順位の遺族がいないことを証する「戸籍謄本」(「除籍謄本」、「改製原戸籍謄本」を含む）　　　　　　※上記3がない場合\\n　　6. 請求者（受給権者）の現在の「戸籍抄本」又は「戸籍謄本」　　※上記４又は５の戸籍謄本より請求者（受給権者）が除籍されている場合\\n　　7. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411108_08:
      "　「認証文つき法定相続情報一覧図の写し」、「戸籍謄本」、「除籍謄本」、「改製原戸籍謄本」は原本を郵送してください。",
    LBLR411108_09:
      "　また、以下書類については、アップロードではなく、福祉医療機構へ郵送してください。\\n　　2. 配偶者の「戸籍謄本」（但し、職員の死亡後に別戸籍となっている場合は、配偶者の「戸籍謄本」のほか職員の死亡を証する「戸籍謄本」又は「除籍謄本」）",
    LBLR411108_10:
      "　また、以下書類については、アップロードではなく、福祉医療機構へ郵送してください。\\n　　2. 職員の死亡及び戸籍上の配偶者がいないことを証する「戸籍謄本」又は「除籍謄本」\\n　　3. 内縁の妻又は夫の「戸籍謄本」",
    LBLR411108_11:
      "　また、以下書類については、アップロードではなく、福祉医療機構へ郵送してください。\\n　　3. 職員の死亡を証する「戸籍謄本」又は「除籍謄本」\\n　　4. 職員と請求者（受給権者）の身分関係及び先順位の遺族がいないことを証する「戸籍謄本」(「除籍謄本」、「改製原戸籍謄本」を含む）\\n　　5. 請求者（受給権者）の現在の「戸籍抄本」又は「戸籍謄本」　　※上記３又は４の戸籍謄本より請求者（受給権者）が除籍されている場合\\n　　6. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411108_12:
      "　また、以下書類については、アップロードではなく、福祉医療機構へ郵送してください。\\n　　3. 「認証文つき法定相続情報一覧図の写し」\\n　　4. 職員の死亡を証する「戸籍謄本」又は「除籍謄本」　　　　　　※上記3がない場合\\n　　5. 職員と請求者（受給権者）の身分関係及び先順位の遺族がいないことを証する「戸籍謄本」(「除籍謄本」、「改製原戸籍謄本」を含む）　　　　　　※上記3がない場合\\n　　6. 請求者（受給権者）の現在の「戸籍抄本」又は「戸籍謄本」　　※上記４又は５の戸籍謄本より請求者（受給権者）が除籍されている場合\\n　　7. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411108_13:
      "　※同順位の遺族（請求者）が２人以上いる場合、「代表者請求における委任状をダウンロード」を押して、必要事項を入力してください。",
    LBLR411108_14:
      "　必要書類に委任状と戸籍謄本が含まれる場合には、以下に郵送してください。",
    LBLR411108_15:
      "　【郵送先】\\n　　〒105－8486\\n　　東京都港区虎ノ門４－３－１３　ヒューリック神谷町ビル９階\\n　　独立行政法人福祉医療機構　共済部退職給付課　宛",
    LBLR411108_16:
      "　以下書類については、福祉医療機構へ郵送してください。\\n　　1. 「認証文つき法定相続情報一覧図の写し」\\n　　2. 職員の相続人（受給権者）を証する「戸籍謄本」　　　　　　※上記1がない場合\\n　　3. 相続人（受給権者）全員の現在の「戸籍抄本」又は「戸籍謄本」　　　　　　※上記1がない場合\\n　　4. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411109_01:
      "　次の表に記載の内容をアップロードし、「次へ」ボタンを押してください。",
    LBLR411110_01:
      "　「退職所得の受給に関する申告書」とは、退職手当等の支給を受ける人が、所得税法第２０３条１項各号に掲げる事項を申告書に記載し、退職手当等の支払者（福祉医療機構）に提出する書類です。\\n　この申告書を提出することにより、適正な退職所得の額と所得税額が計算され、源泉徴収が行われます。\\n　なお、退職所得の受給に関する申告書の記載内容について、疑義のある場合は、最寄りの税務署（源泉所得税担当）へお問合せください。\\n　以降の画面で、「退職所得の受給に関する申告書」の登録となります。",
    LBLR411110_02:
      "　退職手当の支払者の所在地（住所）：〒105－8486　東京都港区虎ノ門4－3－13\\n　退職手当の支払者の名称（氏名）：独立行政法人福祉医療機構\\n　退職手当の支払者の法人番号：８０１０４０５００３６８８",
    LBLR411112_01:
      "　新たに追加する源泉徴収票に記載されている内容を以下に入力するとともに、源泉徴収票をアップロードいただき、完了後、「登録」ボタンを押してください。",
    LBLR411114_01: "　連絡先を登録してください",
    LBLR411118_01:
      "　被共済職員期間（前勤務先での勤務期間）を合算するためには表示されている期間までに再び次の共済契約者に雇用され、被共済職員となる必要があります。\\n　再就職した際は、表示されている引継ぎコードを再就職先の担当者へ伝えていただき、合算制度の利用を機構へ申し出てください。\\n　※合算制度利用は、共済契約者を通じて機構へ申し出ていただくこととなります。\\n　なお、期限までに再就職が出来ない場合は、退職手当金を請求してください。\\n　※引継ぎコードは必ずお控えください（画面のスクリーンショットなどを行ってください）。",
    LBLR411119_01: "　退職手当金の受領者となる方の情報を入力してください。",
    LBLR411120_01: "　今回の退職手当金の請求者を選択してください。",
    LBLR411120_02:
      "　（※1）請求者が戸籍上の配偶者又は内縁の夫・妻以外の場合は、勤務先法人から生活維持の有無を証明する書類（生計維持に関する調査書）の提出が別途必要となります。\\n　（※2）あなたと同順位の請求権保持者がいる場合、書類（委任状）の提出が別途必要となります。",
    LBLR411120_03:
      "　以下に、相続人請求時の必要な書類の一覧を記載します。\\n　退職手当金の請求に必要な書類ですので、ご準備ください。",
    LBLR411120_04:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 配偶者の「戸籍謄本」（但し、職員の死亡後に別戸籍となっている場合は、配偶者の「戸籍謄本」のほか職員の死亡を証する「戸籍謄本」又は「除籍謄本」）",
    LBLR411120_05:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡及び戸籍上の配偶者がいないことを証する「戸籍謄本」又は「除籍謄本」\\n　　3. 内縁の妻又は夫の「戸籍謄本」\\n　　4. 内縁関係についての「生計維持に関する調査書」（様式１１号）\\n　　5. 職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」\\n　　6. その他、事実上の配偶者であることを証明する書類",
    LBLR411120_06:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）\\n　　3. 職員の死亡を証する「戸籍謄本」又は「除籍謄本」\\n　　4. 職員と請求者（受給権者）の身分関係及び先順位の遺族がいないことを証する「戸籍謄本」(「除籍謄本」、「改製原戸籍謄本」を含む）\\n　　5. 請求者（受給権者）の現在の「戸籍抄本」又は「戸籍謄本」　　※上記３又は４の戸籍謄本より請求者（受給権者）が除籍されている場合\\n　　6. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411120_07:
      "　　1. 「死亡診断書」又は「死体検案書」（写）\\n　　2. 職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）\\n　　3. 「認証文つき法定相続情報一覧図の写し」\\n　　4. 職員の死亡を証する「戸籍謄本」又は「除籍謄本」\\n　　5. 職員と請求者（受給権者）の身分関係及び先順位の遺族がいないことを証する「戸籍謄本」(「除籍謄本」、「改製原戸籍謄本」を含む）\\n　　6. 請求者（受給権者）の現在の「戸籍抄本」又は「戸籍謄本」　　※上記４又は５の戸籍謄本より請求者（受給権者）が除籍されている場合\\n　　7. 「委任状」（事務取扱要領様式１２号）　　　　　　　　　　　※同順位の遺族（請求者）が２人以上いる場合",
    LBLR411121_01:
      "　退職手当金の受給権者の順位は民法により順位が決まっています。\\n　登録いただいた内容を基に機構にて受給権者であることの確認を行います。\\n　確認のため、次の書類のアップロードを行い、「次へ」ボタンを押してください。",
    LBLR411123_01:
      "　次の項目について、請求者の情報を入力してください。\\n　初期表示されている内容と事実が異なる場合は、内容修正してください。",
    LBLR411124_01:
      "　退職手当金の振込先金融機関を登録し、「次へ」ボタンを押してください。",
    LBLR411125_01:
      "　【相続人請求において必要な書類の添付】\\n　今回の退職手当金の請求にあたって、次の書類の添付が必要となります。",
    LBLR411126_01:
      "　【本人確認の書類の添付】\\n　退職手当金の請求にあたって、次の書類の添付が必要となります。\\n　・本人であることを確認するための書類\\n　・個人番号を確認できる書類\\n　・振込先口座が確認できる書類\\n　それぞれの添付をアップロードし、「次へ」ボタンを押してください。",
    LBLS080001_01:
      "　掛金納付対象職員届に記載された各年４月１日現在の確定された職員の状況をダウンロードできます。\\n　（確定前は表示されません。）\\n　貴会への情報提供に同意いただいた共済契約者の情報のみ表示されます。",
    LBLW030001_01:
      "　契約のお申込みに係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW040002_01:
      "　「俸給の調整額」の新規登録に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW040002_02: "　法人として認められている手当の一覧です。",
    LBLW040002_03:
      "　申請をする手当の名称と給与規程の対応規程を入力してください。",
    LBLW040002_04: "　施設を選択してください。",
    LBLW040002_05:
      "　申請する規程に該当する条文の該当部分をそのまま記載し、基本事項を満たしているか確認してください。",
    LBLW040002_06: "　給与規程をアップロードしてください。",
    LBLW050001_01:
      "　社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW050002_01:
      "　被共済職員全員の同意を得た退職手当共済契約解除通知書に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW050003_01:
      "　中小企業退職金共済契約締結届に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW050005_01:
      "　措置入所障害児関係業務従事職員数または特定職員数が異なる場合訂正してください。\\n　入力内容を確認後、「機構へ提出する」ボタンを押してください。",
    LBLW050006_01:
      "　施設転換後非加入の届に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW050006_02:
      "　社会福祉施設等から特定介護保険施設等に転換する施設の情報を確認してください。",
    LBLW050006_03: "　転換後の施設情報を確認してください。",
    LBLW050007_01:
      "　施設転換後非加入の取下げ届に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW050008_01:
      "　共済契約対象施設等一部廃止等届に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW050009_01:
      "　退職手当共済契約部分解除通知書に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW060003_01:
      "　共済契約対象(外)施設等異動届に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW060005_01:
      "　被共済職員退職届に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW060006_01: "　退職者情報を確認してください。",
    LBLW060101_01: "　施設を選択すると職員の登録内容が表示されます",
    LBLW060101_02:
      "　１）「ならない月」を登録してください。　\\n　２）育児休業をとった職員、育児休業の終了日を変更する職員がいる場合に、登録してください。　\\n　３）退職予定の職員がいる場合に退職予定日を登録してください。",
    LBLW070007_01:
      "　解除対象となる法人に該当する共済法令違反の内容を確認し、解除年月日を入力してください。",
    LBLW070011_01: "　被共済職員加入届に係る情報です。",
    LBLW080003_01:
      "　掛金納付対象職員届での登録内容と4月1日付で登録した施設・事業に基づき、納付する金額情報です。",
    LBLW080004_01:
      "　掛金納付期限延長承認申請書に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW100003_01: "　ID・権限内容を検索して一覧表示します。",
    LBLW100004_01:
      "　新規登録する機構職員の情報を入力し、「登録」ボタンを押してください。",
    LBLW100005_01: "　パスワードを登録し、「更新」ボタンを押してください。",
    LBLW110001_01:
      "　契約者が実施した申請・届出等に対して機構職員の処理が必要な項目を機構職員要処理一覧に表示しています。\\n　機構職員要処理一覧に表示されている全ての項目に対して処理が必要です。",
    LBLW110002_01:
      "　以下の内容で変更します。\\n　内容に間違いが無いことを確認後、「変更」ボタンを押してください。",
    LBLW110005_01:
      "　申請・届出選択を入力し、次へボタンを押下してください。\\n　契約者（法人）名の入力が必要な場合は、法人検索を押下して、契約者名を選択してください。",
    LBLW120002_01:
      "　※職員番号★…平成１８年３月３１日までの加入者\\n　※職員番号◆…平成１８年４月１日から平成２８年３月３１日までの加入者\\n　※職員番号☆…施設転換前の加入者",
    LBLW140001_01:
      "　新たに追加したいメール・帳票テンプレート、或いは詳細を確認したい追加済みのテンプレートに該当するメール種別を選択してください。",
    LBLW140002_01: "　テンプレート化するメールの情報を入力してください。",
    LBLW140003_01: "　メールの情報を修正してください。",
    LBLW150002_01: "　連絡を行う法人の担当者または代行者を選択してください。",
    LBLW410001_01:
      "　退職手当金請求書に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW410002_01:
      "　合算制度利用申出に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW410004_01:
      "　退職手当金受領者の変更連絡に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW410005_01:
      "　退職手当金請求（退職手当金受領者の変更）に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW410006_01:
      "　退職手当金請求（振込先金融機関の変更）に係る情報です。\\n　内容を確認後、各処理ボタンで処理を実施してください。",
    LBLW410030_01: "　退職手当金請求の取下げに係る情報です。",
    LBLC060106_01:
      "　当該施設・事業に在籍している加入対象の職員を一人ずつ登録する場合は「職員登録」ボタンを押してください。\\n　<施設に在籍している加入対象の職員をまとめて一括で登録する場合には、「職員情報登録様式のダウンロード」ボタンを押して、様式をダウンロードして、入力のうえ、「職員情報登録様式のアップロード」ボタンを押して、登録してください。\\n　他の施設から配置換えとなる職員については、「修正」ボタンを押して本俸月額、従業状況を更新してください。\\n　なお、複数の施設・事業を兼務する職員については、１日の労働時間のうち、２/３以上従事している施設・事業の職員として登録してください。\\n　「兼務職員」及び「加入要件を満たさない職員」のみの施設・事業であり、加入登録する職員数が「０名」となる施設・事業については、画面下部にある「以下に該当する職員はすべて登録しました」に☑を入れ、「登録完了」ボタンを押してください。",
    LBLC080103_01:
      "　次の内容で掛金納付対象職員届を提出します。\\n　登録した内容に誤りがなければ、「納付する掛金を確認する」ボタンを押してください。",
    SCRW020001_01:
      "　新システムにおけるシステムマニュアルを以下に案内しています。",
    SCRW020001_02:
      "　新システムへのログイン方法やシステムメニュー構成について、全体像を把握するための資料です。",
    SCRW020001_03:
      "　共済契約者・施設・施設に在籍する職員にかかる各種情報について、共済契約者や退職者等から機構に対して問い合わせがあった場合に、照会対象となる情報にアクセスするための機能です。",
    SCRW020001_04:
      "　共済契約者や退職者から機構へ提出された申請・届出に対して、要処理対応を実施するための機能です。\\n　また、未対応の申請・届出が存在する共済契約者を一覧形式で管理するための機能も備えています。",
    SCRW020001_05:
      "　機構職員が共済契約者や退職者に代わり、申請・届出を実施するための機能です。",
    SCRW020001_07:
      "　掛金届の提出状況や掛金の納付状況について、一覧形式で管理するための機能です。",
    SCRW020001_08:
      "　共済契約者や退職者から提出された被共済職員退職届、退職手当金請求書の処理状況等を一覧形式で管理するための機能です。",
    SCRW020001_09:
      "　収納・納付請求機能には、次のような機能が備えられています。",
    SCRW020001_10:
      "　・掛金や割増金の納付など、「機構への入金」にかかるデータをアップロードし、管理する機能\\n　・各種「機構からの請求」にかかるデータを一元管理する機能\\n　・退職手当金の支給や過納掛金の返還など、「機構からの送金」処理を行う際に必要となる振込データをダウンロードする機能\\n　・割増金の請求/過納掛金の返還対象となる共済契約者を一覧形式で確認する機能",
    SCRW020001_11:
      "　各都道府県からの補助金の概算および追加交付状況を管理するための機能です。",
    SCRW020001_12:
      "　処理タイプや年度等の抽出条件を指定したうえで、各処理タイプに該当するファイル（データ）のうち、業務に必要となるものをダウンロードするための機能です。",
    SCRW020001_13:
      "　共済契約者のアカウント情報（ログインID・システム利用ステータス・連絡先等）および機構職員のアカウント情報（機構ユーザID・機構職員氏名・所属課等）を一元管理するための機能です。",
    SCRW020001_14:
      "　機構から共済契約者や退職者宛にメールを送付するための機能、共済契約者とやり取りをするための「共済契約者との連絡掲示板」機能です。",
    SCRW020001_15:
      "　退職手当共済システムで利用される４つのメール種別に該当するメールのテンプレートを一元管理するための機能です。",
    SCRW020001_16:
      "　・通知メール（共済契約者や機構職員のシステム操作により自動で送付されるもの　例：受付メール等）\\n　・システム案内メール（期限をトリガーとしてシステムにより自動送付されるもの　例：退職届の提出督促案内メール等）\\n　・定期案内メール（予め送付のタイミング・時刻が定まっているメール　例：本俸月額の更新案内メール等）\\n　・職員手動メール（送信メール機能を用いて機構職員自らが送付を行うメール　例：個別の共済契約者等への照会メール等）",
    SCRW020001_17:
      "　以下に記載の４つの手続きの流れについて、機構職員参照用として纏めた資料です。",
    SCRW020001_18:
      "　・退職手当金支給予定額の証明依頼手続き\\n　・被共済職員原簿の閲覧請求手続き\\n　・退職手当金の返還請求手続き\\n　・退職手当金の追加支給要望",
    SCRC020002_01:
      "　新システムにおけるシステムマニュアルを以下に案内しています。",
    SCRC020002_02:
      "　「社会福祉施設職員等退職手当共済契約申込書」の提出手続きとは、社会福祉施設職員等退職手当共済制度への加入を希望する法人が、機構に対して退職手当共済契約締結の申込みを行う際に行う手続きです。",
    SCRC020002_03:
      "　「施設等新設届・申出書」の提出手続きとは、共済契約者が社会福祉施設等に該当する施設・事業を新たに経営することとなった際、特定介護保険施設等又は申出施設等に該当する施設・事業を任意に機構に申出て共済制度に加入することとなった際に行う手続きです。",
    SCRC020002_04:
      "　「被共済職員加入届」の提出手続きとは、加入要件を満たした職員が共済制度に加入する際に行う手続きです。",
    SCRC020002_05:
      "　「掛金納付対象職員届」の提出手続きとは、当年度 4 月 1 日現在の被共済職員の在籍状況及び異動者状況並びに前年度の従業状況を報告いただく際に行う手続きです。当該届出をもとに当年度の掛金額が決定され、共済契約者は５月末までに掛金を納付いただくこととなります。",
    SCRC020002_06:
      "　「掛金の振込依頼書及び掛金納付対象職員届（共済契約者控え）のダウンロード手続き」とは掛金納付対象職員届を提出いただいた後、掛金の振込依頼書をダウンロードし、当年度の掛金を５月末日までに納付いただくとともに共済契約者控えをダウンロードして保存する際に行う手続きです。",
    SCRC020002_07:
      "　「都道府県社会福祉協議会等への掛金納付対象職員届データの提供の同意にかかる有無選択手続き」とは、社会福祉施設職員等退職手当共済制度（当制度）のほかに都道府県社会福祉協議会等が運営する退職金共済制度に加入されている場合、一部の都道府県においては、掛金納付対象職員届の確定したデータ（自法人分の情報すべて）を施設所在地の都道府県の社会福祉協議会等にシステム上で提供することが可能となるため、提供を行うか否か、選択する際に行う手続きです。",
    SCRC020002_08:
      "　「掛金納付期限延長申請書」の提出手続きとは、災害やその他やむを得ない理由により掛金を納付期限内に納付できないときに、納付期限の延長を申し出るための手続きです。",
    SCRC020002_09:
      "　「被共済職員退職届」の提出手続きとは、被共済職員が退職した際に行う手続きです。",
    SCRC020002_10:
      "　「被共済職員退職届」の取下げ手続きとは、退職の取りやめ等の理由により提出済みの被共済職員退職届を取下げる際に行う手続きです。",
    SCRC020002_11:
      "　配置換え登録手続きとは、人事異動等で施設・事業間を異動する際に行う手続きです。なお、共済契約の対象外となっている施設・事業への異動または契約対象外となっている施設・事業から、対象施設・事業への復帰を行う場合も配置換え登録手続きから行います。",
    SCRC020002_12:
      "　本俸月額の更新手続きとは、在籍する被共済職員の「俸給表の額」および「俸給の調整額」を更新する際に行う手続きです。",
    SCRC020002_13:
      "　「俸給の調整額」対象手当登録申請書の提出手続きとは、「俸給の調整額」としたい手当がある際に行う手続きです。",
    SCRC020002_14:
      "　「共済契約者氏名等変更届・共済契約証書再交付申出書」の提出手続きとは、共済契約者の名称および住所、共済契約対象施設等の名称および所在地、施設種類を変更する場合、または共済契約証書の再交付を申し出る際に行う手続きです。ここでは、共済契約者の名称や所在地等の変更がある場合について、説明します。",
    SCRC020002_15:
      "　「共済契約者氏名等変更届・共済契約証書再交付申出書」の提出手続きとは、共済契約者の名称および住所、共済契約対象施設等の名称および所在地、施設種類を変更する場合、または共済契約証書の再交付を申し出る際に行う手続きです。ここでは、共済契約者の名称や所在地等の変更がある場合について、説明します。",
    SCRC020002_16:
      "　従業状況の更新手続きとは、在籍する被共済職員の従業状況を更新する際に行う手続きです。",
    SCRC020002_17:
      "　「共済契約対象施設等一部廃止届」の提出手続きとは、共済契約対象施設等の一部について、廃止もしくは休止、または経営を移管した際に行う手続きです。",
    SCRC020002_18:
      "　「社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届」の提出手続きとは、共済契約者が経営する施設・事業を廃止、休止または経営移管した結果、社会福祉施設等及び特定介護保険施設等に該当する施設・事業を経営しなくなった際に行う手続きです。",
    SCRC020002_19:
      "　「中小企業退職手当金共済契約締結届」の提出手続きとは、共済契約にかかる被共済職員について、共済契約者が中小企業退職金共済法の規定による退職金共済契約を締結した際に行う手続きです。",
    SCRC020002_20:
      "　「退職手当共済契約解除通知書」の提出手続きとは、被共済職員全員の同意を得て、共済契約の解除を希望するときに際に行う手続きです。",
    SCRC020002_21:
      "　「退職手当共済契約部分解除通知書」の提出手続きとは、施設区分が「特定介護保険施設等」または「申出施設等」に該当する施設について、共済契約の部分的な解除を希望する際に行う手続きです。",
    SCRC020002_22:
      "　「社会福祉施設等から特定介護保険施設等への転換届」の提出手続きとは、施設種類を「軽費老人ホーム（介護保険の指定を受けていないもの）」または「養護老人ホーム」から「軽費老人ホーム（介護保険の指定を受けたもの）」へ変更した際に行う手続きです。",
    SCRC020002_23:
      "　「施設を転換する日以後新たに使用する職員について加入させない旨の届」の提出手続きとは、施設種類が「軽費老人ホーム（介護保険の指定を受けていないもの）」または「養護老人ホーム」から「軽費老人ホーム（介護保険の指定を受けたもの）」に変更され、それに伴い、施設区分も社会福祉施設等から特定介護保険施設等へと変更されたことにより、介護保険の指定日以降に加入する職員の掛金が３倍となるため、当該職員については加入させないことを希望する際に行う手続きです。",
    SCRC020002_24:
      "　制度改正後の職員にかかる非加入届等の取下げ届の提出手続きとは、制度改正時（平成 18 年 4 月 1 日、平成 28 年 4 月 1 日）において、制度改正後の職員を加入させないとして届出を行っている施設・事業、及び「退職手当共済契約部分解除通知書」を提出し、部分解除を行っている施設・事業、又は「施設を転換する日以後新たに使用する職員について加入させない旨の届」を提出している施設・事業において、それらの届出を取下げ、職員（掛金が３倍となる職員）を新たに加入させる際に行う手続きです。 18 年 4 月 1 日、平成 28 年 4 月 1 日）において、制度改正後の職員を加入させないとして届出を行っている施設・事業、及び「退職手当共済契約部分解除通知書」を提出し、部分解除を行っている施設・事業、又は「施設を転換する日以後新たに使用する職員について加入させない旨の届」を提出している施設・事業において、それらの届出を取下げ、職員（掛金が３倍となる職員）を新たに加入させる際に行う手続きです。",
    SCRC020002_25:
      "　「退職手当共済電子届出システムパスワードの再設定手続き」とは、ログインパスワードを失念したときに、新しいパスワードを設定する際に行う手続きです。",
    SCRC020002_26:
      "　退職手当共済電子届出システム登録メールアドレスの変更申請及びパスワードの再設定手続きとは、登録メールアドレスおよびログインパスワードの両方を失念したときに、登録メールアドレスを変更し、パスワードを再設定するための手続きです。",
    SCRC020002_27:
      "　退職者様向けのシステムマニュアルを以下に案内しています。共済契約者様から退職者様へお渡しいただき、ご活用ください。",
    SCRC020002_28:
      "　「退職手当金請求書」の提出手続きとは、退職者等が機構に対して退職手当金の請求をする際に行う手続きです。",
    SCRC020002_29:
      "　「退職手当金請求書」の取下げ手続きとは、何らかの理由により提出済みの退職手当金請求書を取下げる際に行う手続きです。",
    SCRC020002_30:
      "　退職手当金振込先金融機関の変更手続きとは、退職手当金が振込先口座情報の不備等の理由により送金ができなかった際に、正しい振込先金融機関情報に変更を行うための手続きです。",
    SCRC020002_31:
      "　退職者の死亡による退職手当金受領者の変更手続きとは、退職手当金の受領者となる退職者が死亡したことにより、口座が凍結され、機構が退職手当金を送金することができない場合に、退職手当金の受領者を変更し、退職手当金を再請求するための手続きです。",
    SCRC020002_32:
      "　「合算制度利用申出書（退職時）」の提出手続きとは、３年以内に再び被共済職員となる予定があり、再び被共済職員となったときの被共済職員期間を合算して退職手当金を請求する意思がある場合に、今回の退職時には退職手当金は請求せず、被共済職員期間の合算を行うとして機構に意思表示を行う手続きです。\\n　なお、合算制度を利用するための手続きは再び被共済職員となる際の加入時にも行う必要があります。\\n　加入時においては、今回の退職時の手続きにより発行される引継ぎコードを再び被共済職員となる次の共済契約者に引き渡していただき、共済契約者経由で機構に手続きを行います。",
  } as { [key: string]: string },
} as const;
